// import React, { useEffect, useState } from 'react';
// import {
// 	Box,
// 	Typography,
// 	Table,
// 	TableHead,
// 	TableBody,
// 	TableRow,
// 	Button,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions,
// 	Skeleton,
// 	Grid,
// 	TableCell,
// 	Paper,
// 	Chip,
// 	IconButton,
// 	useTheme,
// 	Divider,
// 	// Card,
// 	// CardContent,
// 	// Stack,
// } from '@mui/material';
// import {
// 	BarChart,
// 	Bar,
// 	PieChart,
// 	Pie,
// 	Cell as ChartCell,
// 	XAxis,
// 	YAxis,
// 	CartesianGrid,
// 	Tooltip,
// 	Legend,
// 	ResponsiveContainer,
// } from 'recharts';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import CloseIcon from '@mui/icons-material/Close';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import InventoryIcon from '@mui/icons-material/Inventory';
// import PeopleIcon from '@mui/icons-material/People';
// import EventIcon from '@mui/icons-material/Event';
// import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
// import { useNavigate } from 'react-router-dom';
// import { format } from 'date-fns';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { getAllDahboard } from '../../services/api/Dashboard';
// import CustomTooltip from '../tooltip/CustomTooltip';
// import { DashboardCard } from './DashboardCard';

// // Define types
// interface CardData {
// 	id: string;
// 	title: string;
// 	amount: string | number;
// 	description: string;
// 	icon: React.ReactNode;
// 	color: string;
// }

// interface StatusData {
// 	status: string;
// 	count: number;
// 	color: string;
// }

// interface Inquiry {
// 	_id: string;
// 	name: string;
// 	email: string;
// 	mobile: string;
// 	functionDate: string;
// 	location: string;
// 	status: string;
// 	totalPrice: number;
// 	quotationId: string;
// 	menuTypes: {
// 		menuType: string;
// 		numberOfPersons: number;
// 		price: number;
// 	}[];
// }

// // Custom card component

// const HomePage = () => {
// 	const theme = useTheme();
// 	const navigate = useNavigate();
// 	const [cardData, setCardData] = useState<CardData[]>([]);
// 	const [recentInquiries, setRecentInquiries] = useState<Inquiry[]>([]);
// 	const [quotationStatusData, setQuotationStatusData] = useState<StatusData[]>([]);
// 	const [contactStatusData, setContactStatusData] = useState<StatusData[]>([]);
// 	const [bookingStatusData, setBookingStatusData] = useState<StatusData[]>([]);
// 	const [loading, setLoading] = useState(true);
// 	const [selectedInquiry, setSelectedInquiry] = useState<Inquiry | null>(null);
// 	const [open, setOpen] = useState(false);

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				setLoading(true);
// 				const response = await getAllDahboard();
// 				const data = response.data;

// 				const updatedCardData: CardData[] = [
// 					{
// 						id: '1',
// 						title: 'Categories',
// 						amount: data.categoryCount,
// 						description: 'Total categories',
// 						icon: <InventoryIcon style={{ color: 'white' }} />,
// 						color: '#FF6B6B',
// 					},
// 					{
// 						id: '2',
// 						title: 'Subcategories',
// 						amount: data.subcategoryCount,
// 						description: 'Total subcategories',
// 						icon: <ShoppingCartIcon style={{ color: 'white' }} />,
// 						color: '#4ECDC4',
// 					},
// 					{
// 						id: '3',
// 						title: 'Inquiries',
// 						amount: data.quotationCount,
// 						description: 'Total inquiries',
// 						icon: <PeopleIcon style={{ color: 'white' }} />,
// 						color: '#45B7D1',
// 					},
// 					{
// 						id: '4',
// 						title: 'Bookings',
// 						amount: data.bookingCount,
// 						description: 'Total bookings',
// 						icon: <EventIcon style={{ color: 'white' }} />,
// 						color: '#A78BFA',
// 					},
// 					{
// 						id: '5',
// 						title: 'Revenue',
// 						amount: `₹${data.totalRevenueAmount.toLocaleString()}`,
// 						description: 'Total revenue',
// 						icon: <CurrencyRupeeIcon style={{ color: 'white' }} />,
// 						color: '#F6AD55',
// 					},
// 				];

// 				setCardData(updatedCardData);
// 				setRecentInquiries(data.recentInquiries || []);
// 				setQuotationStatusData(data.statusDataQuotation || []);
// 				setContactStatusData(data.statusDataContact || []);
// 				setBookingStatusData(data.statusDataBooking || []);
// 			} catch (error) {
// 				console.error('Error fetching dashboard data:', error);
// 			} finally {
// 				setLoading(false);
// 			}
// 		};

// 		fetchData();
// 	}, []);

// 	const handleViewAllClick = () => {
// 		navigate('/quotation');
// 	};

// 	const handleClickOpen = (inquiry: Inquiry) => {
// 		setSelectedInquiry(inquiry);
// 		setOpen(true);
// 	};

// 	const handleClose = () => {
// 		setOpen(false);
// 	};

// 	const handleOnDragEnd = (result: any) => {
// 		if (!result.destination) return;

// 		const items = Array.from(cardData);
// 		const [reorderedItem] = items.splice(result.source.index, 1);
// 		items.splice(result.destination.index, 0, reorderedItem);
// 		setCardData(items);
// 	};

// 	const renderCustomizedLabel = ({
// 		cx,
// 		cy,
// 		midAngle,
// 		innerRadius,
// 		outerRadius,
// 		percent,
// 	}: any) => {
// 		const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
// 		const x = cx + radius * Math.cos((-midAngle * Math.PI) / 180);
// 		const y = cy + radius * Math.sin((-midAngle * Math.PI) / 180);

// 		return (
// 			<text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
// 				{`${(percent * 100).toFixed(0)}%`}
// 			</text>
// 		);
// 	};

// 	const getStatusColor = (status: string) => {
// 		switch (status) {
// 			case 'Quotation Send':
// 				return 'primary';
// 			case 'Rejected':
// 				return 'error';
// 			case 'New':
// 				return 'info';
// 			case 'Confirmed':
// 				return 'success';
// 			case 'Converted':
// 				return 'success';
// 			default:
// 				return 'default';
// 		}
// 	};

// 	return (
// 		<Box sx={{ p: 3 }} overflow={'auto'} height={'80vh'}>
// 			<DragDropContext onDragEnd={handleOnDragEnd}>
// 				<Droppable droppableId="cards" direction="horizontal">
// 					{(provided) => (
// 						<Grid
// 							container
// 							spacing={3}
// 							ref={provided.innerRef}
// 							{...provided.droppableProps}
// 							sx={{ mb: 4 }}
// 						>
// 							{loading
// 								? [...Array(5)].map((_, index) => (
// 										<Grid item xs={12} sm={6} md={2.4} key={index}>
// 											<Skeleton
// 												variant="rectangular"
// 												height={140}
// 												sx={{ borderRadius: '12px' }}
// 											/>
// 										</Grid>
// 									))
// 								: cardData.map((card, index) => (
// 										<Draggable
// 											key={card.id}
// 											draggableId={card.id}
// 											index={index}
// 										>
// 											{(provided) => (
// 												<Grid
// 													item
// 													xs={12}
// 													sm={6}
// 													md={2.4}
// 													key={index}
// 													ref={provided.innerRef}
// 													{...provided.draggableProps}
// 													{...provided.dragHandleProps}
// 												>
// 													<DashboardCard
// 														title={card.title}
// 														amount={card.amount}
// 														description={card.description}
// 														icon={card.icon}
// 														color={card.color}
// 													/>
// 												</Grid>
// 											)}
// 										</Draggable>
// 									))}
// 							{provided.placeholder}
// 						</Grid>
// 					)}
// 				</Droppable>
// 			</DragDropContext>
// 			<Grid container spacing={3} sx={{ mb: 3 }}>
// 				{' '}
// 				<Grid item xs={12} md={4}>
// 					{' '}
// 					<Paper
// 						elevation={0}
// 						sx={{
// 							p: 3,
// 							height: '100%',
// 							borderRadius: '16px',
// 							backgroundColor: theme.palette.background.paper,
// 							boxShadow: '0 8px 32px 0 rgba(0,0,0,0.05)',
// 						}}
// 					>
// 						<Typography variant="h6" fontWeight="bold" mb={2}>
// 							Quotation Status
// 						</Typography>
// 						<Divider sx={{ mb: 3 }} />
// 						<ResponsiveContainer width="100%" height={300}>
// 							<PieChart>
// 								<Pie
// 									data={quotationStatusData}
// 									cx="50%"
// 									cy="50%"
// 									labelLine={false}
// 									label={renderCustomizedLabel}
// 									outerRadius={80}
// 									fill="#8884d8"
// 									dataKey="count"
// 									nameKey="status"
// 								>
// 									{quotationStatusData.map((entry, index) => (
// 										<ChartCell key={`cell-${index}`} fill={entry.color} />
// 									))}
// 								</Pie>
// 								<Tooltip content={<CustomTooltip />} />
// 								<Legend
// 									layout="vertical"
// 									verticalAlign="middle"
// 									align="right"
// 									wrapperStyle={{ paddingLeft: '20px' }}
// 								/>
// 							</PieChart>
// 						</ResponsiveContainer>
// 					</Paper>
// 				</Grid>
// 				<Grid item xs={12} md={4}>
// 					<Paper
// 						elevation={0}
// 						sx={{
// 							p: 3,
// 							height: '100%',
// 							borderRadius: '16px',
// 							backgroundColor: theme.palette.background.paper,
// 							boxShadow: '0 8px 32px 0 rgba(0,0,0,0.05)',
// 						}}
// 					>
// 						<Typography variant="h6" fontWeight="bold" mb={2}>
// 							Contact Status
// 						</Typography>
// 						<Divider sx={{ mb: 3 }} />
// 						<ResponsiveContainer width="100%" height={300}>
// 							<BarChart
// 								data={contactStatusData}
// 								layout="vertical"
// 								margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
// 							>
// 								<CartesianGrid
// 									strokeDasharray="3 3"
// 									stroke={theme.palette.divider}
// 								/>
// 								<XAxis type="number" stroke={theme.palette.text.secondary} />
// 								<YAxis
// 									dataKey="status"
// 									type="category"
// 									width={80}
// 									stroke={theme.palette.text.secondary}
// 								/>
// 								<Tooltip
// 									content={<CustomTooltip />}
// 									cursor={{ fill: theme.palette.action.hover }}
// 								/>
// 								<Legend />
// 								<Bar dataKey="count" radius={[0, 4, 4, 0]}>
// 									{contactStatusData.map((entry, index) => (
// 										<ChartCell key={`cell-${index}`} fill={entry.color} />
// 									))}
// 								</Bar>
// 							</BarChart>
// 						</ResponsiveContainer>
// 					</Paper>
// 				</Grid>
// 				<Grid item xs={12} md={4}>
// 					<Paper
// 						elevation={0}
// 						sx={{
// 							p: 3,
// 							height: '100%',
// 							borderRadius: '16px',
// 							backgroundColor: theme.palette.background.paper,
// 							boxShadow: '0 8px 32px 0 rgba(0,0,0,0.05)',
// 						}}
// 					>
// 						<Typography variant="h6" fontWeight="bold" mb={2}>
// 							Booking Status
// 						</Typography>
// 						<Divider sx={{ mb: 3 }} />
// 						<ResponsiveContainer width="100%" height={300}>
// 							<PieChart>
// 								<Pie
// 									data={bookingStatusData}
// 									cx="50%"
// 									cy="50%"
// 									innerRadius={60}
// 									outerRadius={80}
// 									fill="#8884d8"
// 									paddingAngle={5}
// 									dataKey="count"
// 									nameKey="status"
// 									label
// 								>
// 									{bookingStatusData.map((entry, index) => (
// 										<ChartCell key={`cell-${index}`} fill={entry.color} />
// 									))}
// 								</Pie>
// 								<Tooltip content={<CustomTooltip />} />
// 								<Legend
// 									layout="vertical"
// 									verticalAlign="middle"
// 									align="right"
// 									wrapperStyle={{ paddingLeft: '20px' }}
// 								/>
// 							</PieChart>
// 						</ResponsiveContainer>
// 					</Paper>
// 				</Grid>
// 			</Grid>

// 			<Paper
// 				elevation={0}
// 				sx={{
// 					p: 3,
// 					borderRadius: '16px',
// 					backgroundColor: theme.palette.background.paper,
// 					boxShadow: '0 8px 32px 0 rgba(0,0,0,0.05)',
// 				}}
// 			>
// 				<Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
// 					<Typography variant="h6" fontWeight="bold">
// 						Recent Quotation
// 					</Typography>
// 					<Button
// 						variant="outlined"
// 						onClick={handleViewAllClick}
// 						sx={{
// 							borderRadius: '8px',
// 							textTransform: 'none',
// 							fontWeight: 'bold',
// 						}}
// 					>
// 						View All
// 					</Button>
// 				</Box>
// 				<Divider sx={{ mb: 3 }} />
// 				<Box sx={{ overflow: 'auto' }}>
// 					<Table sx={{ minWidth: 750 }}>
// 						<TableHead>
// 							<TableRow>
// 								<TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
// 								<TableCell sx={{ fontWeight: 'bold' }}>Contact</TableCell>
// 								<TableCell sx={{ fontWeight: 'bold' }}>Event Date</TableCell>
// 								<TableCell sx={{ fontWeight: 'bold' }}>Location</TableCell>
// 								<TableCell sx={{ fontWeight: 'bold' }}>Total Price</TableCell>
// 								<TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
// 								<TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
// 							</TableRow>
// 						</TableHead>
// 						<TableBody>
// 							{loading ? (
// 								[...Array(5)].map((_, index) => (
// 									<TableRow key={index}>
// 										{[...Array(7)].map((_, cellIndex) => (
// 											<TableCell key={cellIndex}>
// 												<Skeleton variant="text" />
// 											</TableCell>
// 										))}
// 									</TableRow>
// 								))
// 							) : recentInquiries.length > 0 ? (
// 								recentInquiries.map((inquiry) => (
// 									<TableRow
// 										key={inquiry._id}
// 										hover
// 										sx={{
// 											'&:last-child td, &:last-child th': { border: 0 },
// 											cursor: 'pointer',
// 										}}
// 									>
// 										<TableCell>
// 											<Typography fontWeight="medium">
// 												{inquiry.name}
// 											</Typography>
// 										</TableCell>
// 										<TableCell>
// 											<Box>
// 												<Typography variant="body2">
// 													{inquiry.email}
// 												</Typography>
// 												<Typography variant="body2" color="text.secondary">
// 													{inquiry.mobile}
// 												</Typography>
// 											</Box>
// 										</TableCell>
// 										<TableCell>
// 											{format(new Date(inquiry.functionDate), 'MMM dd, yyyy')}
// 										</TableCell>
// 										<TableCell>{inquiry.location}</TableCell>
// 										<TableCell>
// 											<Typography fontWeight="medium">
// 												₹{inquiry.totalPrice.toFixed(2)}
// 											</Typography>
// 										</TableCell>
// 										<TableCell>
// 											<Chip
// 												label={inquiry.status}
// 												color={getStatusColor(inquiry.status)}
// 												size="small"
// 												sx={{
// 													borderRadius: '6px',
// 													fontWeight: 'bold',
// 												}}
// 											/>
// 										</TableCell>
// 										<TableCell>
// 											<IconButton
// 												onClick={() => handleClickOpen(inquiry)}
// 												sx={{
// 													backgroundColor: theme.palette.action.hover,
// 													'&:hover': {
// 														backgroundColor:
// 															theme.palette.action.selected,
// 													},
// 												}}
// 											>
// 												<VisibilityIcon fontSize="small" />
// 											</IconButton>
// 										</TableCell>
// 									</TableRow>
// 								))
// 							) : (
// 								<TableRow>
// 									<TableCell colSpan={7} align="center" sx={{ py: 4 }}>
// 										<Typography color="text.secondary">
// 											No recent inquiries found
// 										</Typography>
// 									</TableCell>
// 								</TableRow>
// 							)}
// 						</TableBody>
// 					</Table>
// 				</Box>

// 				<Dialog
// 					open={open}
// 					onClose={handleClose}
// 					maxWidth="md"
// 					fullWidth
// 					PaperProps={{
// 						sx: {
// 							borderRadius: '16px',
// 						},
// 					}}
// 				>
// 					<DialogTitle
// 						sx={{
// 							display: 'flex',
// 							justifyContent: 'space-between',
// 							alignItems: 'center',
// 							// backgroundColor: theme.palette.primary.main,
// 							color: 'black',
// 						}}
// 					>
// 						Quotation Details
// 						<IconButton
// 							aria-label="close"
// 							onClick={handleClose}
// 							sx={{
// 								color: 'white',
// 							}}
// 						>
// 							<CloseIcon />
// 						</IconButton>
// 					</DialogTitle>
// 					<DialogContent sx={{ p: 4 }}>
// 						{selectedInquiry && (
// 							<Box>
// 								<Grid container spacing={4}>
// 									<Grid item xs={12} md={6}>
// 										<Typography variant="h6" fontWeight="bold" mb={2}>
// 											Customer Information
// 										</Typography>
// 										<Box sx={{ mb: 3 }}>
// 											<Typography variant="body2" color="text.secondary">
// 												Name
// 											</Typography>
// 											<Typography variant="body1" mb={2}>
// 												{selectedInquiry.name}
// 											</Typography>

// 											<Typography variant="body2" color="text.secondary">
// 												Email
// 											</Typography>
// 											<Typography variant="body1" mb={2}>
// 												{selectedInquiry.email}
// 											</Typography>

// 											<Typography variant="body2" color="text.secondary">
// 												Mobile
// 											</Typography>
// 											<Typography variant="body1" mb={2}>
// 												{selectedInquiry.mobile}
// 											</Typography>

// 											<Typography variant="body2" color="text.secondary">
// 												Quotation ID
// 											</Typography>
// 											<Typography variant="body1">
// 												{selectedInquiry.quotationId}
// 											</Typography>
// 										</Box>

// 										<Typography variant="h6" fontWeight="bold" mb={2}>
// 											Event Details
// 										</Typography>
// 										<Box>
// 											<Typography variant="body2" color="text.secondary">
// 												Date
// 											</Typography>
// 											<Typography variant="body1" mb={2}>
// 												{format(
// 													new Date(selectedInquiry.functionDate),
// 													'MMM dd, yyyy'
// 												)}
// 											</Typography>

// 											<Typography variant="body2" color="text.secondary">
// 												Location
// 											</Typography>
// 											<Typography variant="body1">
// 												{selectedInquiry.location}
// 											</Typography>
// 										</Box>
// 									</Grid>

// 									<Grid item xs={12} md={6}>
// 										<Typography variant="h6" fontWeight="bold" mb={2}>
// 											Financial Information
// 										</Typography>
// 										<Box sx={{ mb: 3 }}>
// 											<Typography variant="body2" color="text.secondary">
// 												Total Price
// 											</Typography>
// 											<Typography variant="h5" fontWeight="bold" mb={2}>
// 												₹{selectedInquiry.totalPrice.toFixed(2)}
// 											</Typography>

// 											<Typography variant="body2" color="text.secondary">
// 												Status
// 											</Typography>
// 											<Chip
// 												label={selectedInquiry.status}
// 												color={getStatusColor(selectedInquiry.status)}
// 												size="medium"
// 												sx={{
// 													borderRadius: '6px',
// 													fontWeight: 'bold',
// 												}}
// 											/>
// 										</Box>

// 										{selectedInquiry.menuTypes.length > 0 && (
// 											<>
// 												<Typography variant="h6" fontWeight="bold" mb={2}>
// 													Menu Details
// 												</Typography>
// 												<Box
// 													sx={{
// 														backgroundColor: theme.palette.action.hover,
// 														borderRadius: '12px',
// 														p: 2,
// 													}}
// 												>
// 													{selectedInquiry.menuTypes.map(
// 														(menu, index) => (
// 															<Box
// 																key={index}
// 																sx={{
// 																	mb: 2,
// 																	pb: 2,
// 																	borderBottom:
// 																		index !==
// 																		selectedInquiry.menuTypes
// 																			.length -
// 																			1
// 																			? `1px solid ${theme.palette.divider}`
// 																			: 'none',
// 																}}
// 															>
// 																<Typography fontWeight="medium">
// 																	{menu.menuType}
// 																</Typography>
// 																<Typography variant="body2">
// 																	{menu.numberOfPersons} persons
// 																</Typography>
// 																<Typography
// 																	variant="body2"
// 																	color="primary"
// 																>
// 																	₹{menu.price.toFixed(2)}
// 																</Typography>
// 															</Box>
// 														)
// 													)}
// 												</Box>
// 											</>
// 										)}
// 									</Grid>
// 								</Grid>
// 							</Box>
// 						)}
// 					</DialogContent>
// 					<DialogActions sx={{ p: 3 }}>
// 						<Button
// 							onClick={handleClose}
// 							sx={{
// 								borderRadius: '8px',
// 								textTransform: 'none',
// 								fontWeight: 'bold',
// 							}}
// 						>
// 							Close
// 						</Button>
// 					</DialogActions>
// 				</Dialog>
// 			</Paper>
// 		</Box>
// 	);
// };

// export default HomePage;
import React, { useEffect, useState } from 'react';
import {
	Box,
	Typography,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Skeleton,
	Grid,
	TableCell,
	Paper,
	Chip,
	IconButton,
	useTheme,
	Divider,
	useMediaQuery,
} from '@mui/material';
import {
	BarChart,
	Bar,
	PieChart,
	Pie,
	Cell as ChartCell,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from 'recharts';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CloseIcon from '@mui/icons-material/Close';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import InventoryIcon from '@mui/icons-material/Inventory';
import PeopleIcon from '@mui/icons-material/People';
import EventIcon from '@mui/icons-material/Event';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getAllDahboard } from '../../services/api/Dashboard';
import CustomTooltip from '../tooltip/CustomTooltip';
import { DashboardCard } from './DashboardCard';

// Define types
interface CardData {
	id: string;
	title: string;
	amount: string | number;
	description: string;
	icon: React.ReactNode;
	color: string;
}

interface StatusData {
	status: string;
	count: number;
	color: string;
}

interface Inquiry {
	_id: string;
	name: string;
	email: string;
	mobile: string;
	functionDate: string;
	location: string;
	status: string;
	totalPrice: number;
	quotationId: string;
	menuTypes: {
		menuType: string;
		numberOfPersons: number;
		price: number;
	}[];
}

const HomePage = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
	// const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

	const [cardData, setCardData] = useState<CardData[]>([]);
	const [recentInquiries, setRecentInquiries] = useState<Inquiry[]>([]);
	const [quotationStatusData, setQuotationStatusData] = useState<StatusData[]>([]);
	const [contactStatusData, setContactStatusData] = useState<StatusData[]>([]);
	const [bookingStatusData, setBookingStatusData] = useState<StatusData[]>([]);
	const [loading, setLoading] = useState(true);
	const [selectedInquiry, setSelectedInquiry] = useState<Inquiry | null>(null);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const response = await getAllDahboard();
				const data = response.data;

				const updatedCardData: CardData[] = [
					{
						id: '1',
						title: 'Categories',
						amount: data.categoryCount,
						description: 'Total categories',
						icon: <InventoryIcon style={{ color: 'white' }} />,
						color: '#FF6B6B',
					},
					{
						id: '2',
						title: 'Subcategories',
						amount: data.subcategoryCount,
						description: 'Total subcategories',
						icon: <ShoppingCartIcon style={{ color: 'white' }} />,
						color: '#4ECDC4',
					},
					{
						id: '3',
						title: 'Inquiries',
						amount: data.quotationCount,
						description: 'Total inquiries',
						icon: <PeopleIcon style={{ color: 'white' }} />,
						color: '#45B7D1',
					},
					{
						id: '4',
						title: 'Bookings',
						amount: data.bookingCount,
						description: 'Total bookings',
						icon: <EventIcon style={{ color: 'white' }} />,
						color: '#A78BFA',
					},
					{
						id: '5',
						title: 'Revenue',
						amount: `${data.totalRevenueAmount.toLocaleString()}`,
						description: 'Total revenue',
						icon: <CurrencyRupeeIcon style={{ color: 'white' }} />,
						color: '#F6AD55',
					},
				];

				setCardData(updatedCardData);
				setRecentInquiries(data.recentInquiries || []);
				setQuotationStatusData(data.statusDataQuotation || []);
				setContactStatusData(data.statusDataContact || []);
				setBookingStatusData(data.statusDataBooking || []);
			} catch (error) {
				console.error('Error fetching dashboard data:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	const handleViewAllClick = () => {
		navigate('/quotation');
	};

	const handleClickOpen = (inquiry: Inquiry) => {
		setSelectedInquiry(inquiry);
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleOnDragEnd = (result: any) => {
		if (!result.destination) return;

		const items = Array.from(cardData);
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);
		setCardData(items);
	};

	const renderCustomizedLabel = ({
		cx,
		cy,
		midAngle,
		innerRadius,
		outerRadius,
		percent,
	}: any) => {
		const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
		const x = cx + radius * Math.cos((-midAngle * Math.PI) / 180);
		const y = cy + radius * Math.sin((-midAngle * Math.PI) / 180);

		return (
			<text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
				{`${(percent * 100).toFixed(0)}%`}
			</text>
		);
	};

	const getStatusColor = (status: string) => {
		switch (status) {
			case 'Quotation Send':
				return 'primary';
			case 'Rejected':
				return 'error';
			case 'New':
				return 'info';
			case 'Confirmed':
				return 'success';
			case 'Converted':
				return 'success';
			default:
				return 'default';
		}
	};

	// Determine card grid size based on screen size
	const getCardGridSize = () => {
		if (isSmallScreen) return 12;
		if (isMediumScreen) return 6;
		return 2.4;
	};

	// Determine chart grid size based on screen size
	const getChartGridSize = () => {
		if (isSmallScreen) return 12;
		if (isMediumScreen) return 6;
		return 4;
	};

	return (
		<Box sx={{ p: { xs: 1, sm: 2, md: 3 } }} overflow={'auto'} height={'80vh'}>
			<DragDropContext onDragEnd={handleOnDragEnd}>
				<Droppable droppableId="cards" direction="horizontal">
					{(provided) => (
						<Grid
							container
							spacing={3}
							ref={provided.innerRef}
							{...provided.droppableProps}
							sx={{ mb: 4 }}
						>
							{loading
								? [...Array(5)].map((_, index) => (
										<Grid
											item
											xs={12}
											sm={6}
											md={getCardGridSize()}
											key={index}
										>
											<Skeleton
												variant="rectangular"
												height={140}
												sx={{ borderRadius: '12px' }}
											/>
										</Grid>
									))
								: cardData.map((card, index) => (
										<Draggable
											key={card.id}
											draggableId={card.id}
											index={index}
										>
											{(provided) => (
												<Grid
													item
													xs={12}
													sm={6}
													md={getCardGridSize()}
													key={index}
													ref={provided.innerRef}
													{...provided.draggableProps}
													{...provided.dragHandleProps}
												>
													<DashboardCard
														title={card.title}
														amount={card.amount}
														description={card.description}
														icon={card.icon}
														color={card.color}
													/>
												</Grid>
											)}
										</Draggable>
									))}
							{provided.placeholder}
						</Grid>
					)}
				</Droppable>
			</DragDropContext>

			<Grid container spacing={3} sx={{ mb: 3 }}>
				<Grid item xs={12} md={getChartGridSize()}>
					<Paper
						elevation={0}
						sx={{
							p: 3,
							height: '100%',
							borderRadius: '16px',
							backgroundColor: theme.palette.background.paper,
							boxShadow: '0 8px 32px 0 rgba(0,0,0,0.05)',
						}}
					>
						<Typography variant="h6" fontWeight="bold" mb={2}>
							Quotation Status
						</Typography>
						<Divider sx={{ mb: 3 }} />
						<ResponsiveContainer width="100%" height={300}>
							<PieChart>
								<Pie
									data={quotationStatusData}
									cx="50%"
									cy="50%"
									labelLine={false}
									label={renderCustomizedLabel}
									outerRadius={80}
									fill="#8884d8"
									dataKey="count"
									nameKey="status"
								>
									{quotationStatusData.map((entry, index) => (
										<ChartCell key={`cell-${index}`} fill={entry.color} />
									))}
								</Pie>
								<Tooltip content={<CustomTooltip />} />
								<Legend
									layout={isSmallScreen ? 'horizontal' : 'vertical'}
									verticalAlign={isSmallScreen ? 'bottom' : 'middle'}
									align={isSmallScreen ? 'center' : 'right'}
									wrapperStyle={{
										paddingLeft: isSmallScreen ? 0 : '20px',
										paddingTop: isSmallScreen ? '20px' : 0,
									}}
								/>
							</PieChart>
						</ResponsiveContainer>
					</Paper>
				</Grid>

				<Grid item xs={12} md={getChartGridSize()}>
					<Paper
						elevation={0}
						sx={{
							p: 3,
							height: '100%',
							borderRadius: '16px',
							backgroundColor: theme.palette.background.paper,
							boxShadow: '0 8px 32px 0 rgba(0,0,0,0.05)',
						}}
					>
						<Typography variant="h6" fontWeight="bold" mb={2}>
							Contact Status
						</Typography>
						<Divider sx={{ mb: 3 }} />
						<ResponsiveContainer width="100%" height={300}>
							<BarChart
								data={contactStatusData}
								layout="vertical"
								margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
							>
								<CartesianGrid
									strokeDasharray="3 3"
									stroke={theme.palette.divider}
								/>
								<XAxis type="number" stroke={theme.palette.text.secondary} />
								<YAxis
									dataKey="status"
									type="category"
									width={80}
									stroke={theme.palette.text.secondary}
								/>
								<Tooltip
									content={<CustomTooltip />}
									cursor={{ fill: theme.palette.action.hover }}
								/>
								<Legend />
								<Bar dataKey="count" radius={[0, 4, 4, 0]}>
									{contactStatusData.map((entry, index) => (
										<ChartCell key={`cell-${index}`} fill={entry.color} />
									))}
								</Bar>
							</BarChart>
						</ResponsiveContainer>
					</Paper>
				</Grid>

				<Grid item xs={12} md={getChartGridSize()}>
					<Paper
						elevation={0}
						sx={{
							p: 3,
							height: '100%',
							borderRadius: '16px',
							backgroundColor: theme.palette.background.paper,
							boxShadow: '0 8px 32px 0 rgba(0,0,0,0.05)',
						}}
					>
						<Typography variant="h6" fontWeight="bold" mb={2}>
							Booking Status
						</Typography>
						<Divider sx={{ mb: 3 }} />
						<ResponsiveContainer width="100%" height={300}>
							<PieChart>
								<Pie
									data={bookingStatusData}
									cx="50%"
									cy="50%"
									innerRadius={60}
									outerRadius={80}
									fill="#8884d8"
									paddingAngle={5}
									dataKey="count"
									nameKey="status"
									label
								>
									{bookingStatusData.map((entry, index) => (
										<ChartCell key={`cell-${index}`} fill={entry.color} />
									))}
								</Pie>
								<Tooltip content={<CustomTooltip />} />
								<Legend
									layout={isSmallScreen ? 'horizontal' : 'vertical'}
									verticalAlign={isSmallScreen ? 'bottom' : 'middle'}
									align={isSmallScreen ? 'center' : 'right'}
									wrapperStyle={{
										paddingLeft: isSmallScreen ? 0 : '20px',
										paddingTop: isSmallScreen ? '20px' : 0,
									}}
								/>
							</PieChart>
						</ResponsiveContainer>
					</Paper>
				</Grid>
			</Grid>

			<Paper
				elevation={0}
				sx={{
					p: 3,
					borderRadius: '16px',
					backgroundColor: theme.palette.background.paper,
					boxShadow: '0 8px 32px 0 rgba(0,0,0,0.05)',
				}}
			>
				<Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
					<Typography variant="h6" fontWeight="bold">
						Recent Quotation
					</Typography>
					<Button
						variant="outlined"
						onClick={handleViewAllClick}
						sx={{
							borderRadius: '8px',
							textTransform: 'none',
							fontWeight: 'bold',
						}}
					>
						View All
					</Button>
				</Box>
				<Divider sx={{ mb: 3 }} />
				<Box sx={{ overflow: 'auto' }}>
					<Table sx={{ minWidth: 750 }}>
						<TableHead>
							<TableRow>
								<TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
								{!isSmallScreen && (
									<>
										<TableCell sx={{ fontWeight: 'bold' }}>Contact</TableCell>
										<TableCell sx={{ fontWeight: 'bold' }}>
											Event Date
										</TableCell>
										<TableCell sx={{ fontWeight: 'bold' }}>Location</TableCell>
										<TableCell sx={{ fontWeight: 'bold' }}>
											Total Price
										</TableCell>
									</>
								)}
								<TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
								<TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{loading ? (
								[...Array(5)].map((_, index) => (
									<TableRow key={index}>
										{[...Array(isSmallScreen ? 3 : 7)].map((_, cellIndex) => (
											<TableCell key={cellIndex}>
												<Skeleton variant="text" />
											</TableCell>
										))}
									</TableRow>
								))
							) : recentInquiries.length > 0 ? (
								recentInquiries.map((inquiry) => (
									<TableRow
										key={inquiry._id}
										hover
										sx={{
											'&:last-child td, &:last-child th': { border: 0 },
											cursor: 'pointer',
										}}
									>
										<TableCell>
											<Typography fontWeight="medium">
												{inquiry.name}
											</Typography>
											{isSmallScreen && (
												<>
													<Typography
														variant="body2"
														color="text.secondary"
													>
														{inquiry.mobile}
													</Typography>
													<Typography variant="body2">
														₹{inquiry.totalPrice.toFixed(2)}
													</Typography>
												</>
											)}
										</TableCell>
										{!isSmallScreen && (
											<>
												<TableCell>
													<Box>
														<Typography variant="body2">
															{inquiry.email}
														</Typography>
														<Typography
															variant="body2"
															color="text.secondary"
														>
															{inquiry.mobile}
														</Typography>
													</Box>
												</TableCell>
												<TableCell>
													{format(
														new Date(inquiry.functionDate),
														'MMM dd, yyyy'
													)}
												</TableCell>
												<TableCell>{inquiry.location}</TableCell>
												<TableCell>
													<Typography fontWeight="medium">
														₹{inquiry?.totalPrice?.toFixed(2)}
													</Typography>
												</TableCell>
											</>
										)}
										<TableCell>
											<Chip
												label={inquiry.status}
												color={getStatusColor(inquiry.status)}
												size="small"
												sx={{
													borderRadius: '6px',
													fontWeight: 'bold',
												}}
											/>
										</TableCell>
										<TableCell>
											<IconButton
												onClick={() => handleClickOpen(inquiry)}
												sx={{
													backgroundColor: theme.palette.action.hover,
													'&:hover': {
														backgroundColor:
															theme.palette.action.selected,
													},
												}}
											>
												<VisibilityIcon fontSize="small" />
											</IconButton>
										</TableCell>
									</TableRow>
								))
							) : (
								<TableRow>
									<TableCell
										colSpan={isSmallScreen ? 3 : 7}
										align="center"
										sx={{ py: 4 }}
									>
										<Typography color="text.secondary">
											No recent inquiries found
										</Typography>
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</Box>

				<Dialog
					open={open}
					onClose={handleClose}
					maxWidth="md"
					fullWidth
					fullScreen={isSmallScreen}
					PaperProps={{
						sx: {
							borderRadius: isSmallScreen ? 0 : '16px',
						},
					}}
				>
					<DialogTitle
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							color: 'black',
						}}
					>
						Quotation Details
						<IconButton aria-label="close" onClick={handleClose}>
							<CloseIcon />
						</IconButton>
					</DialogTitle>
					<DialogContent sx={{ p: isSmallScreen ? 2 : 4 }}>
						{selectedInquiry && (
							<Box>
								<Grid container spacing={isSmallScreen ? 2 : 4}>
									<Grid item xs={12} md={6}>
										<Typography variant="h6" fontWeight="bold" mb={2}>
											Customer Information
										</Typography>
										<Box sx={{ mb: 3 }}>
											<Typography variant="body2" color="text.secondary">
												Name
											</Typography>
											<Typography variant="body1" mb={2}>
												{selectedInquiry.name}
											</Typography>

											<Typography variant="body2" color="text.secondary">
												Email
											</Typography>
											<Typography variant="body1" mb={2}>
												{selectedInquiry.email}
											</Typography>

											<Typography variant="body2" color="text.secondary">
												Mobile
											</Typography>
											<Typography variant="body1" mb={2}>
												{selectedInquiry.mobile}
											</Typography>

											<Typography variant="body2" color="text.secondary">
												Quotation ID
											</Typography>
											<Typography variant="body1">
												{selectedInquiry.quotationId}
											</Typography>
										</Box>

										<Typography variant="h6" fontWeight="bold" mb={2}>
											Event Details
										</Typography>
										<Box>
											<Typography variant="body2" color="text.secondary">
												Date
											</Typography>
											<Typography variant="body1" mb={2}>
												{format(
													new Date(selectedInquiry.functionDate),
													'MMM dd, yyyy'
												)}
											</Typography>

											<Typography variant="body2" color="text.secondary">
												Location
											</Typography>
											<Typography variant="body1">
												{selectedInquiry.location}
											</Typography>
										</Box>
									</Grid>

									<Grid item xs={12} md={6}>
										<Typography variant="h6" fontWeight="bold" mb={2}>
											Financial Information
										</Typography>
										<Box sx={{ mb: 3 }}>
											<Typography variant="body2" color="text.secondary">
												Total Price
											</Typography>
											<Typography variant="h5" fontWeight="bold" mb={2}>
												₹{selectedInquiry.totalPrice.toFixed(2)}
											</Typography>

											<Chip
												label={selectedInquiry.status}
												color={getStatusColor(selectedInquiry.status)}
												size="medium"
												sx={{
													borderRadius: '6px',
													fontWeight: 'bold',
												}}
											/>
										</Box>

										{selectedInquiry.menuTypes.length > 0 && (
											<>
												<Typography variant="h6" fontWeight="bold" mb={2}>
													Menu Details
												</Typography>
												<Box
													sx={{
														backgroundColor: theme.palette.action.hover,
														borderRadius: '12px',
														p: 2,
													}}
												>
													{selectedInquiry.menuTypes.map(
														(menu, index) => (
															<Box
																key={index}
																sx={{
																	mb: 2,
																	pb: 2,
																	borderBottom:
																		index !==
																		selectedInquiry.menuTypes
																			.length -
																			1
																			? `1px solid ${theme.palette.divider}`
																			: 'none',
																}}
															>
																<Typography fontWeight="medium">
																	{menu.menuType}
																</Typography>
																<Typography variant="body2">
																	{menu.numberOfPersons} persons
																</Typography>
																<Typography
																	variant="body2"
																	color="primary"
																>
																	₹{menu.price.toFixed(2)}
																</Typography>
															</Box>
														)
													)}
												</Box>
											</>
										)}
									</Grid>
								</Grid>
							</Box>
						)}
					</DialogContent>
					<DialogActions sx={{ p: isSmallScreen ? 2 : 3 }}>
						<Button
							onClick={handleClose}
							sx={{
								borderRadius: '8px',
								textTransform: 'none',
								fontWeight: 'bold',
							}}
						>
							Close
						</Button>
					</DialogActions>
				</Dialog>
			</Paper>
		</Box>
	);
};

export default HomePage;
